import { render, staticRenderFns } from "./BetfairPage.vue?vue&type=template&id=180cfb04&scoped=true&"
import script from "./BetfairPage.vue?vue&type=script&lang=js&"
export * from "./BetfairPage.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BetfairPage.vue?vue&type=style&index=1&id=180cfb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cfb04",
  null
  
)

export default component.exports